jQuery(document).ready(function($){

!function(r){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=r(require("jquery")):r(jQuery)}(function(r){"use strict";var t={bgVertical:function(r,t){return r.css({"background-position":"center "+-t+"px"})},bgHorizontal:function(r,t){return r.css({"background-position":-t+"px center"})},vertical:function(r,t,o){return"none"!==o||(o=""),r.css({"-webkit-transform":"translateY("+t+"px)"+o,"-moz-transform":"translateY("+t+"px)"+o,transform:"translateY("+t+"px)"+o,transition:"transform linear","will-change":"transform"})},horizontal:function(r,t,o){return"none"!==o||(o=""),r.css({"-webkit-transform":"translateX("+t+"px)"+o,"-moz-transform":"translateX("+t+"px)"+o,transform:"translateX("+t+"px)"+o,transition:"transform linear","will-change":"transform"})}},o={factor:function(r,t,o){var n=r.data("paroller-factor"),a=n||o.factor;if(t<576){var e=r.data("paroller-factor-xs"),i=e||o.factorXs;return i||a}if(t<=768){var c=r.data("paroller-factor-sm"),f=c||o.factorSm;return f||a}if(t<=1024){var l=r.data("paroller-factor-md"),u=l||o.factorMd;return u||a}if(t<=1200){var s=r.data("paroller-factor-lg"),d=s||o.factorLg;return d||a}if(t<=1920){var g=r.data("paroller-factor-xl"),h=g||o.factorXl;return h||a}return a},bgOffset:function(r,t){return Math.round(r*t)},transform:function(r,t,o,n){return Math.round((r-o/2+n)*t)}},n={background:function(r){return r.css({"background-position":"unset"})},foreground:function(r){return r.css({transform:"unset",transition:"unset"})}};r.fn.paroller=function(a){var e=r(window).height(),i=r(document).height(),a=r.extend({factor:0,factorXs:0,factorSm:0,factorMd:0,factorLg:0,factorXl:0,type:"background",direction:"vertical"},a);return this.each(function(){var c=r(this),f=r(window).width(),l=c.offset().top,u=c.outerHeight(),s=c.data("paroller-type"),d=c.data("paroller-direction"),g=c.css("transform"),h=s||a.type,p=d||a.direction,b=o.factor(c,f,a),m=o.bgOffset(l,b),v=o.transform(l,b,e,u);"background"===h?"vertical"===p?t.bgVertical(c,m):"horizontal"===p&&t.bgHorizontal(c,m):"foreground"===h&&("vertical"===p?t.vertical(c,v,g):"horizontal"===p&&t.horizontal(c,v,g)),r(window).on("resize",function(){var s=r(this).scrollTop();f=r(window).width(),l=c.offset().top,u=c.outerHeight(),b=o.factor(c,f,a),"background"===h?n.background(c):"foreground"===h&&s<=i&&n.foreground(c),m=Math.round(l*b),v=Math.round((l-e/2+u)*b),"background"===h?(n.background(c),"vertical"===p?t.bgVertical(c,m):"horizontal"===p&&t.bgHorizontal(c,m)):"foreground"===h&&s<=i&&(n.foreground(c),"vertical"===p?t.vertical(c,v):"horizontal"===p&&t.horizontal(c,v))}),r(window).on("scroll",function(){var o=r(this).scrollTop();i=r(document).height(),m=Math.round((l-o)*b),v=Math.round((l-e/2+u-o)*b),"background"===h?"vertical"===p?t.bgVertical(c,m):"horizontal"===p&&t.bgHorizontal(c,m):"foreground"===h&&o<=i&&("vertical"===p?t.vertical(c,v,g):"horizontal"===p&&t.horizontal(c,v,g))})})}});

/*search param*/
$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null){
       return null;
    }
    else{
       return decodeURI(results[1]) || 0;
    }
}
/*toggle text*/
$.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
});
	var windowWidth = $(window).width();

	function CallOwlProductCarousel(selector){
		$(selector).owlCarousel({
		    loop:true,
		    margin:20,
		    items:3,
		    dots:false,
		    autoplay:true,
		    autoplayTimeout:6000,
		    responsiveClass:true,
		   	nav:true,
		    navText : ['<i class="leftArrow arrowSlider"></i>','<i class="rightArrow arrowSlider"></i>'],
		    responsive:{
		        300:{items:1},
		        600:{items:2},
		        900:{items:3}
		    }
		});
	}


	$.fn.textWidth = function(){
		  var sensor = $('<div />').css({margin: 0, padding: 0});
		  $(this).append(sensor);
		  var width = sensor.width();
		  sensor.remove();
		  return width;
		};


	if($(".flx-team-carousel .owl-carousel").length) {
  		$('.flx-team-carousel .owl-carousel').owlCarousel({
		    loop:true,
		    margin:0,
		    items:1,
		    nav:true,
		    navText : ['<i class="fa fa-caret-left" aria-hidden="true"></i>','<i class="fa fa-caret-right" aria-hidden="true"></i>'],
		    responsiveClass:true,
		    responsive:{
		        0:{items:1},
		        600:{items:3}
		    }
		});
	}

	if($(".strip-menu.owl-carousel").length) {
  		$('.strip-menu.owl-carousel').owlCarousel({
		    loop:false,
		    rewind: true,
		    margin:0,
		    items:1,
		    nav:true,
		    dots:false,
		    navText : ['<i class="fa fa-caret-left" aria-hidden="true"></i>','<i class="fa fa-caret-right" aria-hidden="true"></i>'],
		    responsiveClass:true,
		    responsive:{
		        0:{items:1},
		        400:{items:3},
		        700:{items:5},
		        1000:{items:7},
		        1200:{items:9}
		    }
		});
	}


	if($(".triggerForOwl.productsCarousel").length) {
		CallOwlProductCarousel('.triggerForOwl.productsCarousel');
	}

	if($(".flx-slider .owl-carousel").length) {

		function ShowText(){
		   setTimeout(
			  function()
			  {
			    $('.flx-slider .owl-carousel .active .text').each(function(index, el) {
			    	$(".flx-slider .owl-carousel .text[data-transition='fade']").css('opacity', '0');
		   			$(".flx-slider .owl-carousel .text[data-transition='slide in']").css('margin-left', '-150%');
			   		transition = 'fade';
			   		delay = '100';
			   		opacity = '0.9';
			   		margin_x ='0';

			   		if(transition=="fade")
			   		{
			   			$(this).show(0).delay(delay).animate({ 'opacity': opacity}, 500);
			   		}
			   		else
			   		{
			   			$(this).show(0).delay(delay).animate({ 'marginLeft': margin_x+'%'}, 500);
			   		}
			    });
			}, 50);
		}

  		$('.flx-slider .owl-carousel').owlCarousel({
		    loop:true,
		    margin:0,
		    nav:true,
		    navText : ['<i class="leftArrow arrowSlider"></i>','<i class="rightArrow arrowSlider"></i>'],
		    items:1,
		    dots:true,
		    autoplay:true,
		    autoplayTimeout:7000,
		    smartSpeed: 1000
		});
		ShowText();

		$('.flx-slider .owl-carousel').on('changed.owl.carousel', function(event) {
		   $('.flx-slider .owl-carousel .text').hide();
		   ShowText();
		});
	}

	if($(".flx-readmore").length) {
			var readMore = 'Mehr';
			var readLess = 'Weniger';
			var link = "<a href='' class='readMore'>"+readMore+"</a>";

		$(".flx-readmore").each(function(index, el) {
			var height = $(this).attr('data-flx-readmore-height');
			var content = $(this).find(".content");

			if(!(height>0)) height=200;

			content.height(height);
			$(link).insertAfter(content);
		});

		$(document).on('click', '.flx-readmore .readMore', function(event) {
			event.preventDefault();		;
			$(this).text(readLess).toggleClass('readMore').toggleClass('readLess').siblings('.content').height('');
		});

		$(document).on('click', '.flx-readmore .readLess', function(event) {
			event.preventDefault();
			var height = $(this).closest('.flx-readmore').attr('data-flx-readmore-height');
			if(!(height>0)) height=200;
			$(this).text(readMore).toggleClass('readMore').toggleClass('readLess').siblings('.content').height(height);
		});
	}

	if($("address").length) {

        $("address").each(function(){
             var embed ="<iframe style='width:100%;height:600px;' frameborder='0' scrolling='no' marginheight='0' marginwidth='0'  src='https://maps.google.com/maps?&amp;q="+
              encodeURIComponent( $(this).text() ) +"&amp;output=embed'></iframe>";
             $(this).html(embed);
       });
	}

	if($(".my-paroller").length) {

 		$('.my-paroller').paroller();
	}


	if($(".cart-number-holder").length) {

 		var cart_number = $('.cart-number-holder').html();
 		$("#menu-item-183 a").append(cart_number);
	}

	$(document).on('click', '.hamburger', function(event) {
		event.preventDefault();
		$(this).toggleClass('change');
		$(".menuContainer").toggleClass('open');
		$("html,body").toggleClass('menuOpen');
	});




	if (windowWidth > 768)
	{
		if($(".same-height").length) {
			setTimeout(function (){

				$('.same-height').each(function(){
			      var highestBox = 0;
			      $('.same-height-children', this).each(function(){
			        if($(this).height() > highestBox) {
			          highestBox = $(this).height();
			        }
			      });
			      highestBox = highestBox + 0;
			      $('.same-height-children',this).height(highestBox);
			    });

			}, 1000);

		}
	}

	if($("body.page-id-44").length && window.location.hash) {
		hash = window.location.hash;
		$(hash).find('.heading a').trigger( "click" );
		$('html, body').animate({
            scrollTop: $(hash).offset().top - 65 }, 700, 'swing', function () {});
	}


	if($("body.page-id-438").length || $("body.page-id-2409").length) {
		$(".holder-for-gallery-titles").append($(".temp-div-for-titles").html());

		$(document).on('click', '.trigger-to-show-gallery', function(event) {
			event.preventDefault();
			$('.gallery-holder').addClass('gallery-hidden');
			$('.trigger-to-show-gallery').addClass('background-color-secondary').removeClass('background-color-primary');

			var current_gallery = $(this).attr('href');
			$(this).removeClass('background-color-secondary').addClass('background-color-primary');
			$(current_gallery).removeClass('gallery-hidden');
		});

		$('.holder-for-gallery-titles .trigger-to-show-gallery:first-child').trigger('click');
	}


	$(document).on('click', '.flx-accordion .heading a', function(e) {
	    e.preventDefault();
	    $(this).closest(".flx-accordion").toggleClass('opened');
	});

	$(document).on('click', '.zaSmanjivanje .moreLess', function(e) {
	    e.preventDefault();
	    $(this).closest('.col-lg-9').toggleClass('otvoreno');
	    $(this).toggleText('mehr lesen ...', 'schließen ▲');
	});

	$(document).on('click', '.my-custom-select a', function(e) {
	    e.preventDefault();
	    var send_to = $(this).data('send-to');
	    var text = $(this).text();
	    $(this).closest('.my-custom-select').find('.dropdown-toggle').text(text);
	    $("#send-to").val(send_to);
	});

	$(document).on('click', '.trigger-for-show-hide-details', function(e) {
	    e.preventDefault();
	    $(this).closest('tr').find('.show-hide-details').slideToggle();
	    $(this).find('i').toggleClass('fa-expand').toggleClass('fa-compress');
	});

	$('#input_1_7').change(function() {
	    $('#input_1_9').val($(this).val());
	});

    $(window).scroll( function(){

        /* Check the location of each desired element */
        $('.hideme').each( function(i){

            var bottom_of_object = $(this).offset().top + $(this).outerHeight();
            var bottom_of_window = $(window).scrollTop() + $(window).height();


			if (window.matchMedia("(max-width: 700px)").matches) {

            	if( bottom_of_window > bottom_of_object-450 )
            	{

	                $(this).animate({'opacity':'1'},500);
	                $(this).find('img').animate({'opacity':'1'},800);
	                $(this).find('h3').animate({'opacity':'1'},1200);
	                $(this).find('h2').animate({'opacity':'1'},1600);
	                $(this).find('p').animate({'opacity':'1'},2000);

	            }

			}
			else
			{
				if( bottom_of_window > bottom_of_object-150 ){

						$(this).animate({'opacity':'1'},500);
						$(this).find('img').animate({'opacity':'1'},800);
						$(this).find('h3').animate({'opacity':'1'},1200);
						$(this).find('h2').animate({'opacity':'1'},1600);
						$(this).find('p').animate({'opacity':'1'},2000);
				}
			}

        });

    });

    $(function() {
	    var navbar = $("nav.navbar");
	    $(window).scroll(function() {
	        var scroll = $(window).scrollTop();

	        if (scroll >= 100) {
	            navbar.addClass("small-header");
	        } else {
	            navbar.removeClass("small-header");
	        }
	    });
	});

    setTimeout(
	  function()
	  {
	    $(".zaSmanjivanje").each(function(index, el) {
	    	var heightLg4=$(this).find(".col-lg-3 div").width();
	    	var heightLg8=$(this).find(".col-lg-9").height();

	    	console.log(heightLg4 + " " +heightLg8)
	    	if(heightLg8>(heightLg4+25))
	    		$(this).find('.col-lg-9 .forShrink').addClass("shrink");
	    });
	}, 500);

	$('.gallery-item a').featherlight({
		targetAttr: 'href'
	});

    if($("#calendar").length){

      var calendarEl = document.getElementById('calendar');
      var eventsJson = $("#calendar").data('events');
      var calendar = new FullCalendar.Calendar(calendarEl, {
        plugins: [ 'dayGrid','momentPlugin' ],
        locale: 'de',
        lang: 'de',
        header: {
              left:   'title',
              center: '',
              right:  'prev,next'
          },
          eventClick: function(info) {
              //var moment = require('moment');
            //moment.locale('cs');
            $(".s-time").text(moment(info.event.start).format('DD. MM. YYYY., HH:mm'));
            $(".e-time").text(moment(info.event.end).format('DD. MM. YYYY., HH:mm'));
            $(".event h3").text(info.event.title);
            $(".loc").text(info.event.extendedProps[0].location);
            $(".event-info-text").text(info.event.extendedProps[0].text);
            $(".no-event").hide(0);
            $(".event").removeClass('d-none').hide(0).slideDown(800);
            console.log(info.event);
        },
        events: eventsJson
      });

      calendar.render();

    }
});
